import { lazy } from 'react';

// project imports
import { t } from 'i18next';
import Planos from '../views/pages/Planos';
import Users from '../views/pages/Users';
import UsersAdd from '../views/pages/UsersAdd';
import InfoUser from '../views/pages/Users/infoUser';
import SeeUser from '../views/pages/SeeUser';
import QuestionnaireManagerPatient from '../views/pages/QuestionnaireViewer/index_paciente';
import QuestionnaireManager from '../views/pages/QuestionnaireBuilder';
import FilledFormsViewer from '../views/pages/QuestionnaireBuilder/FilledFormViewer';
import Profile from '../views/pages/Profile';
import Settings from '../views/pages/settings';
import Record from '../views/pages/SeeUser/Record';
import Loadable from '../component/Loadable';
import Groups from '../views/pages/Groups';
import CreateGroup from '../views/pages/Groups/CreateGroup';
import GroupDetails from '../views/pages/Groups/GroupDetails';
import EditGroup from '../views/pages/Groups/EditGroup';
import MeusGrupos from '../views/pages/Groups/MeusGrupos';
import QuestionnaireDetails from '../views/pages/QuestionnaireBuilder/QuestionnaireDetails';
import CreatePlan from '../views/pages/Planos/CreatePlan';
import PlanoDetails from '../views/pages/Planos/PlanoDetails';
import CreateQuestionnaire from '../views/pages/QuestionnaireBuilder/CreateQuestionnaire';
import QuestionnaireAnswerDetails from '../views/pages/QuestionnaireBuilder/QuestionnaireAnswerDetails';
import Messages from '../views/pages/Messages';
import Aprender from '../views/pages/Aprender';
import DuplicatePlan from '../views/pages/Planos/DuplicatePlan';
import MessageChat from '../views/pages/Messages/MessageChat';
import AprenderCriar from '../views/pages/Aprender/AprenderCriar';
import AprenderVer from '../views/pages/Aprender/AprenderVer';
import AprenderEditar from '../views/pages/Aprender/AprenderEditar';
import Nutrition from '../views/pages/Nutricao';
import NutriPlanDetails from '../views/pages/Nutricao/NutriPlanDetails';
import CreateNutritionPlan from '../views/pages/Nutricao/CreateNutritionPlan';
import CreateStressTest from '../views/pages/StressTest/CreateStressTest';
import StressTestRangeConfig from '../views/pages/StressTest/StressTestRangeConfig';
import ViewStressTest from '../views/pages/StressTest/ViewStressTest';
import DuplicateNutritionPlan from '../views/pages/Nutricao/DuplicateNutritionPlan';
import CreateMedicalTestPage from '../views/pages/Exams/CreateMedicalTestPage';
import ViewMedicalTestPage from '../views/pages/SeeUser/components/ViewMedicalTestPage';
import CreateConsultationPage from '../views/pages/Consultation/CreateConsultationPage';
import ViewConsultationPage from '../views/pages/Consultation/ViewConsultationPage';
import AddMedication from '../views/pages/medication';

// dashboard routing
const MedicDashboard = Loadable(lazy(() => import('views/dashboard/Medic')));
const Agenda = Loadable(lazy(() => import('views/pages/Agenda')));
const DocumentationPage = Loadable(
    lazy(() => import('views/documentation/DocumentationPage'))
);
const MedicSinais = Loadable(lazy(() => import('views/pages/Sinais/Medic')));

// utilities routing
const UtilsTypography = Loadable(lazy(() => import('views/utilities/Typography')));
const UtilsColor = Loadable(lazy(() => import('views/utilities/Color')));
const UtilsShadow = Loadable(lazy(() => import('views/utilities/Shadow')));
const UtilsMaterialIcons = Loadable(lazy(() => import('views/utilities/MaterialIcons')));
const UtilsTablerIcons = Loadable(lazy(() => import('views/utilities/TablerIcons')));

// sample page routing
const SamplePage = Loadable(lazy(() => import('views/sample-page')));

// landing page for patients
const PatientLanding = Loadable(lazy(() => import('views/pages/PatientLanding')));

// ===========================|| MAIN ROUTING ||=========================== //

// Role-based main routes
const getMainRoutes = (role) => {
    switch (role) {
        case 'DOCTOR':
            return [
                {
                    path: '/',
                    element: <MedicDashboard />
                },
                {
                    path: '/settings',
                    element: <Settings />
                },
                {
                    path: '/stress-test-ranges',
                    name: t('routes.stress_test_range'),
                    element: <StressTestRangeConfig />
                },
                {
                    path: '/medicSinais',
                    element: <MedicSinais />
                },
                {
                    path: '/dashboard/default',
                    element: <MedicDashboard />
                },

                {
                    path: '/profile',
                    name: t('routes.my_profile'),
                    element: <Profile />
                },
                {
                    path: '/users',
                    name: t('routes.users'),
                    element: <Users />
                },
                {
                    path: '/users/add',
                    name: t('routes.create_user'),
                    element: <UsersAdd />
                },
                {
                    path: '/users/user/edit',
                    name: t('routes.edit_user'),
                    element: <InfoUser />
                },
                {
                    path: '/users/user',
                    name: t('routes.patients'),
                    element: <SeeUser />
                },
                {
                    path: '/users/user/:patientUuid',
                    name: t('routes.patients'),
                    element: <SeeUser />
                },
                {
                    path: '/users/user/:patientUuid/:patientSection',
                    name: t('routes.patients'),
                    element: <SeeUser />
                },
                {
                    path: '/users/user/:patientUuid/atividade/record',
                    name: t('routes.record'),
                    element: <Record />
                },
                {
                    path: '/users/user/stress-test/create',
                    name: t('routes.stress_test'),
                    element: <CreateStressTest />
                },
                {
                    path: '/users/user/medical-test/create',
                    name: t('routes.stress_test'),
                    element: <CreateMedicalTestPage />
                },
                {
                    path: '/users/user/consultation/create',
                    name: t('routes.appointments'),
                    element: <CreateConsultationPage />
                },
                {
                    path: '/users/user/stress-test/:uuid',
                    name: t('routes.stress_test'),
                    element: <ViewStressTest />
                },
                {
                    path: '/users/user/medical-test/:uuid',
                    name: t('routes.exams'),
                    element: <ViewMedicalTestPage />
                },
                {
                    path: '/users/user/consultation/:uuid',
                    name: t('routes.appointment'),
                    element: <ViewConsultationPage />
                },
                {
                    path: '/users/user/record',
                    name: t('routes.record'),
                    element: <Record />
                },
                {
                    path: '/planos',
                    name: t('routes.plans'),
                    element: <Planos />
                },
                {
                    path: '/planos/criar',
                    name: t('routes.create_plan'),
                    element: <CreatePlan />
                },
                {
                    path: '/planos/:uuid',
                    name: t('routes.plan_details'),
                    element: <PlanoDetails />
                },
                {
                    path: '/planos/duplicar/:uuid',
                    name: t('routes.duplicate_plan'),
                    element: <DuplicatePlan />
                },
                {
                    path: '/questionarios',
                    name: t('routes.questionnaires'),
                    element: <QuestionnaireManager />
                },
                {
                    path: '/questionarios/criar',
                    name: t('routes.create_questionnaire'),
                    element: <CreateQuestionnaire />
                },
                {
                    path: '/questionarios/:uuid',
                    name: t('routes.questionnaire_details'),
                    element: <QuestionnaireDetails />
                },
                {
                    path: '/questionarios/resposta/:uuid',
                    name: t('routes.questionnaire_answers'),
                    element: <QuestionnaireAnswerDetails />
                },
                {
                    path: '/questionarios/paciente',
                    element: <QuestionnaireManagerPatient />
                },
                {
                    path: '/questionarios-preenchidos/:pacienteNumUtenteSaude',
                    element: <FilledFormsViewer />
                },
                {
                    path: '/agenda',
                    name: t('pages.calendar'),
                    element: <Agenda />
                },
                {
                    path: '/utils/util-typography',
                    element: <UtilsTypography />
                },
                {
                    path: '/utils/util-color',
                    element: <UtilsColor />
                },
                {
                    path: '/utils/util-shadow',
                    element: <UtilsShadow />
                },
                {
                    path: '/icons/tabler-icons',
                    element: <UtilsTablerIcons />
                },
                {
                    path: '/icons/material-icons',
                    element: <UtilsMaterialIcons />
                },
                {
                    path: '/sample-page',
                    element: <SamplePage />
                },
                {
                    path: '/grupos',
                    name: t('routes.groups'),
                    element: <Groups />
                },
                {
                    path: '/grupos/criar',
                    name: t('routes.create_group'),
                    element: <CreateGroup />
                },
                {
                    path: '/grupos/:groupId',
                    name: t('routes.view_group'),
                    element: <GroupDetails />
                },
                {
                    path: '/grupos/editar/:groupId',
                    name: t('routes.edit_group'),
                    element: <EditGroup />
                },
                {
                    path: '/meusgrupos',
                    name: t('routes.my_groups'),
                    element: <MeusGrupos />
                },
                {
                    path: '/mensagens',
                    name: t('routes.messages'),
                    element: <Messages />
                },
                {
                    path: '/mensagens/:contactId',
                    name: t('routes.message'),
                    element: <MessageChat />
                },
                {
                    path: '/aprender',
                    name: t('routes.learn'),
                    element: <Aprender />
                },
                {
                    path: '/aprender/criar',
                    name: t('routes.create_content'),
                    element: <AprenderCriar />
                },
                {
                    path: '/aprender/:uuid',
                    name: t('routes.view_content'),
                    element: <AprenderVer />
                },
                {
                    path: '/aprender/editar/:uuid',
                    name: t('routes.edit_content'),
                    element: <AprenderEditar />
                },
                {
                    path: '/documentacao',
                    name: t('routes.documentation'),
                    element: <DocumentationPage />
                },
                {
                    path: '/nutricao',
                    name: t('routes.nutrition'),
                    element: <Nutrition />
                },
                {
                    path: '/nutricao/:uuid',
                    name: t('routes.nutrition_details'),
                    element: <NutriPlanDetails />
                },
                {
                    path: '/nutricao/criar',
                    name: t('routes.create_nutrition'),
                    element: <CreateNutritionPlan />
                },
                {
                    path: '/nutricao/duplicar/:uuid',
                    name: t('routes.duplicate_plan'),
                    element: <DuplicateNutritionPlan />
                },
                {
                    path: '/medication/add',
                    name: t('routes.medication'),
                    element: <AddMedication />
                }
            ];
        case 'PATIENT':
            return [
                {
                    path: '/',
                    element: <PatientLanding />
                },
                {
                    path: '/settings',
                    element: <Settings />
                },
                {
                    path: '/profile',
                    name: 'O meu perfil',
                    element: <Profile />
                }
            ];

        case 'CLINIC_CARE_GIVER':
            return [
                {
                    path: '/',
                    element: <PatientLanding />
                }
            ];
        default:
            return [];
    }
};

const getNameByRoute = (routes, path) => {
    for (const route of routes) {
        if (route.path === path) {
            return route?.name;
        }
        if (route.children) {
            const childRoute = getRouteByPath(route.children, path);
            if (childRoute) {
                return childRoute;
            }
        }
    }
    return null;
};

export const getRouteByPath = (path) => {
    return getNameByRoute(getMainRoutes('DOCTOR'), path);
};

export default getMainRoutes;
